// src/services/SubscriptionManager.js
import axiosInstance from "../../utils/axiosInstance"; // for admin
import userAxios from "../../utils/userAxios"; // for users

const BASE_URL = "/subscriptions";

const SubscriptionManager = {
  // 🟩 USER: Subscribe
  async subscribeUser(req) {
    const { data } = await userAxios.post(`${BASE_URL}/subscribe`, req);
    return data.responseData;
  },

  // 🟩 USER: Renew
  async renewSubscription(userId, req) {
    const { data } = await userAxios.post(`${BASE_URL}/${userId}/renew`, req);
    return data.responseData;
  },

  // 🟩 USER: Change plan
  async changeSubscriptionPlan(userId, req) {
    const { data } = await userAxios.post(`${BASE_URL}/change-plan/${userId}`, req);
    return data.responseData;
  },

  // 🟩 USER: Remaining days
  async getRemainingDays(userId) {
    const { data } = await userAxios.get(
      `${BASE_URL}/${userId}/remaining-days`
    );
    return data.responseData;
  },

  // 🟩 USER: Get subscriptions by user
  async getUserSubscriptions(userId) {
    const { data } = await userAxios.get(
      `${BASE_URL}/getSubscriptionByUser/${userId}`
    );
    return data.responseData;
  },

  // 🟩 USER + ADMIN: Get subscription by ID
  async getSubscriptionById(id) {
    const { data } = await userAxios.get(`${BASE_URL}/${id}`);
    return data.responseData;
  },

  // 🟥 ADMIN: Update status
  async updateSubscriptionStatus(id, status) {
    const { data } = await userAxios.put(`${BASE_URL}/${id}/status`, status);
    return data.responseData;
  },

  // 🟥 ADMIN: Active subscribed users
  async getAllSubscribedUsersWithDetails() {
    const { data } = await userAxios.get(`${BASE_URL}/active-users`);
    return data.responseData;
  },

  // 🟥 ADMIN: Expired subscribed users
  async getAllExpiredSubscribedUsersWithDetails() {
    const { data } = await userAxios.get(`${BASE_URL}/expired-users`);
    return data.responseData;
  },

  // ADMIN: Extend subscription days
  async extendSubscription(userId, extraDays) {
    const req = { userId, extraDays };
    const { data } = await axiosInstance.post(`/subscription/extend`, req);
    return data.responseData;
  },
};

export default SubscriptionManager;
